export const campaignsList = {
    title       : 'Campagnes',
    nextCampaign: 'Nouvelle Campagne',
}
